import { PAYMENT_METHOD_ID } from '@/core/payment-methods/constants';

export const ApplePay = () => import('./apple-pay');
export const BancomatPay = () => import('./bancomat-pay');
export const BancontactQrCode = () => import('./bancontact-qr-code');
export const BitPay = () => import('./bitpay');
export const Blik = () => import('./blik/blik-old');
export const BlikDirect = () => import('./blik/blik-direct');
export const BlueCode = () => import('./blue-code');
export const Cash = () => import('./cash');
export const ClickToPay = () => import('./click-to-pay');
export const Dias = () => import('./dias');
export const DirectDebit = () => import('./direct-debit');
export const DirectPay = () => import('./direct-pay');
export const EPS = () => import('./eps');
export const GiroPay = () => import('./giropay/giropay-old');
export const GiroPayDirect = () => import('./giropay/giropay-direct');
export const GooglePay = () => import('./google-pay');
export const Ideal = () => import('./ideal');
export const Iris = () => import('./iris');
export const Klarna = () => import('./klarna');
export const MobilePay = () => import('./mobile-pay');
export const Multibanco = () => import('./multibanco/multibanco-old');
export const MultiBancoReference = () => import('./multibanco/multibanco-reference');
export const MultiBancoWay = () => import('./multibanco/multibanco-way');
export const P24 = () => import('./p24');
export const Payconiq = () => import('./payconiq');
export const PaymentCard = () => import('./payment-card');
export const Paypal = () => import('./paypal');
export const PaymentInitiation = () => import('./payment-initiation');
export const PayOnDelivery = () => import('./pay-on-delivery');
export const PayU = () => import('./payu');
export const SamsungPay = () => import('./samsung-pay');
export const Satispay = () => import('./satispay');
export const Swish = () => import('./swish');
export const TbiBnpl = () => import('./tbi-bnpl');
export const Trustly = () => import('./trustly');
export const Wallet = () => import('./wallet');
export const WeChatPay = () => import('./wechatpay');

export function getPaymentMethodComponent(paymentMethodId: PAYMENT_METHOD_ID) {
    switch (paymentMethodId) {
        case PAYMENT_METHOD_ID.ApplePay:
            return ApplePay;

        case PAYMENT_METHOD_ID.BancomatPay:
            return BancomatPay;

        case PAYMENT_METHOD_ID.BancontactQRCode:
            return BancontactQrCode;

        case PAYMENT_METHOD_ID.BitPay:
            return BitPay;

        case PAYMENT_METHOD_ID.Blik:
            return Blik;

        case PAYMENT_METHOD_ID.BlikDirect:
            return BlikDirect;

        case PAYMENT_METHOD_ID.BlueCode:
            return BlueCode;

        case PAYMENT_METHOD_ID.Cash:
            return Cash;

        case PAYMENT_METHOD_ID.ClickToPay:
            return ClickToPay;

        case PAYMENT_METHOD_ID.CreditCard:
            return PaymentCard;

        case PAYMENT_METHOD_ID.Dias:
            return Dias;

        case PAYMENT_METHOD_ID.DirectDebit:
            return DirectDebit;

        case PAYMENT_METHOD_ID.DirectPay:
            return DirectPay;

        case PAYMENT_METHOD_ID.Eps:
            return EPS;

        case PAYMENT_METHOD_ID.GiroPay:
            return GiroPay;

        case PAYMENT_METHOD_ID.GiroPayDirect:
            return GiroPayDirect;

        case PAYMENT_METHOD_ID.GooglePay:
            return GooglePay;

        case PAYMENT_METHOD_ID.IDeal:
            return Ideal;

        case PAYMENT_METHOD_ID.Iris:
            return Iris;

        case PAYMENT_METHOD_ID.Klarna:
            return Klarna;

        case PAYMENT_METHOD_ID.MobilePay:
            return MobilePay;

        case PAYMENT_METHOD_ID.Multibanco:
            return Multibanco;

        case PAYMENT_METHOD_ID.MultibancoReference:
            return MultiBancoReference;

        case PAYMENT_METHOD_ID.MultibancoWay:
            return MultiBancoWay;

        case PAYMENT_METHOD_ID.P24:
            return P24;

        case PAYMENT_METHOD_ID.PayPal:
            return Paypal;

        case PAYMENT_METHOD_ID.PaymentInitiation:
            return PaymentInitiation;

        case PAYMENT_METHOD_ID.Payconiq:
            return Payconiq;

        case PAYMENT_METHOD_ID.PayOnDelivery:
            return PayOnDelivery;

        case PAYMENT_METHOD_ID.PayU:
            return PayU;

        case PAYMENT_METHOD_ID.SamsungPay:
            return SamsungPay;

        case PAYMENT_METHOD_ID.Swish:
            return Swish;

        case PAYMENT_METHOD_ID.Satispay:
            return Satispay;

        case PAYMENT_METHOD_ID.TbiBnpl:
            return TbiBnpl;

        case PAYMENT_METHOD_ID.Trustly:
            return Trustly;

        case PAYMENT_METHOD_ID.Wallet:
            return Wallet;

        case PAYMENT_METHOD_ID.WeChatPay:
            return WeChatPay;

        default:
            return null;
    }
}
